// extracted by mini-css-extract-plugin
export var badge = "awards-module--badge--ed690";
export var container = "awards-module--container--a9984";